const isMonthShift = (timeValue, shiftMonths = 0) => {
  const inputDate = new Date(timeValue);
  const today = new Date();
  const target = new Date(today.getFullYear(), today.getMonth() + shiftMonths, 1);

  return (
    inputDate.getMonth() === target.getMonth() &&
    inputDate.getFullYear() === target.getFullYear()
  );
};

const toNumber = (v) => Number(v || 0);

const getTicketReferenceFromDetail = (ticketDetailDoc) => {
  
  const rows = ticketDetailDoc?.data;
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const found = rows.find(r => r && r.reference);
  return found?.reference ? String(found.reference) : null;
};

const chooseBest = (a, b) => {
  // a/b: { type: 'ticket'|'invoice', amount, date, ref }
  if (!a) return b;
  if (!b) return a;

  if (b.amount > a.amount) return b;
  if (b.amount < a.amount) return a;

  // empate: gana factura
  if (a.type === 'invoice') return a;
  if (b.type === 'invoice') return b;

  return a;
};

export const getRevenueMonthShiftDedup = (
  ticketsMap,
  ticketDetailMap,
  invoicesMap,
  shiftMonths = 0
) => {
  const byRef = new Map();

  // Tickets del mes agrupados por reference
  Object.entries(ticketsMap || {}).forEach(([ticketId, ticket]) => {
    if (!isMonthShift(ticket.ticketDate, shiftMonths)) return;
    if (ticket.incorrect) return;

    const detail = (ticketDetailMap || {})[ticketId];
    const ref =
      (ticket.taskReference ? String(ticket.taskReference) : null) ||
      getTicketReferenceFromDetail(detail);

    // Si no hay referencia, lo contamos aparte con un key único para no perder ingresos
    const key = ref ? `ref:${ref}` : `ticket:${ticketId}`;

    const candidate = {
      type: 'ticket',
      ref: ref,
      amount: toNumber(ticket.totalPrice),
      date: ticket.ticketDate
    };

    byRef.set(key, chooseBest(byRef.get(key), candidate));
  });

  // Facturas del mes agrupadas por taskReference
  Object.values(invoicesMap || {}).forEach((invoice) => {
    if (!isMonthShift(invoice.invoiceDate, shiftMonths)) return;

    const ref = invoice.taskReference ? String(invoice.taskReference) : null;
    const key = ref ? `ref:${ref}` : `invoice:${invoice.invoiceDate}:${invoice.totalPrice}`;

    const candidate = {
      type: 'invoice',
      ref: ref,
      amount: toNumber(invoice.totalPrice),
      date: invoice.invoiceDate
    };

    byRef.set(key, chooseBest(byRef.get(key), candidate));
  });

  // Sumar el mejor por referencia
  return Array.from(byRef.values()).reduce((acc, item) => acc + item.amount, 0);
};

export const getRevenueMoMDedup = (ticketsMap, ticketDetailMap, invoicesMap) => {
  const current = getRevenueMonthShiftDedup(ticketsMap, ticketDetailMap, invoicesMap, 0);
  const previous = getRevenueMonthShiftDedup(ticketsMap, ticketDetailMap, invoicesMap, -1);

  let percent = 0;
  if (previous === 0) {
    percent = current === 0 ? 0 : null;
  } else {
    percent = ((current - previous) / previous) * 100;
  }

  return { current, previous, percent };
};